import { render } from "./serviceAiqu.vue?vue&type=template&id=6da68392&scoped=true"
import script from "./serviceAiqu.vue?vue&type=script&lang=js"
export * from "./serviceAiqu.vue?vue&type=script&lang=js"

import "./serviceAiqu.vue?vue&type=style&index=0&id=6da68392&scoped=true&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6da68392"]])

export default __exports__